import {
  ChitChatCard,
  MessageType,
  ResearchTaskCreationCard,
  SchedulerCreationCard,
  ImageCard,
  Message,
  MessageSkill,
  TaskState,
} from 'src/types';
import { ThreadMessageContent } from '../../../../../components/FlatAppearance/components/ThreadMessageContent';
import { ThreadScheduleCard } from '../../../../../components/FlatAppearance/components/ThreadScheduleCard';
import { DebugMessageWrapper } from 'src/pages/ManageTasksChatPage/components/TaskScratchpad/components/DebugMessageWrapper';
import { ThreadErrorMessageContent } from 'src/components/FlatAppearance/components/ThreadErrorMessageContent';
import { ErrorPayload } from 'src/types/models/ErrorPayload';
import { ThreadImageGenerationCard } from 'src/components/FlatAppearance/components/ThreadImageGenerationCard';
import { ThreadResearchCard } from 'src/v2/components/ThreadMessage/components/ThreadResearchCard';
import { ThreadChitChatCard } from 'src/v2/components/ThreadMessage/components/ThreadChitChatCard';
import { FeedbackRating } from 'src/v2/components/ThreadMessage/components/FeedbackRating';
import { ThreadVideoGenCard } from '../ThreadVideoGenCard';
import { RelatedQuestions } from 'src/components/RelatedQuestions';

interface ThreadMessageBodyProps {
  message: Message;
  messageId: string;
  isStreaming: boolean;
  messageSkill: MessageSkill | null;
  taskTitle: string;
  isLast: boolean;
  taskState?: TaskState;
  setActiveTab: (activeTab: string) => void;
}

export const ThreadMessageBody = ({
  message,
  messageId,
  isStreaming,
  messageSkill,
  taskTitle,
  isLast,
  taskState,
  setActiveTab,
}: ThreadMessageBodyProps) => {
  const {
    message_type,
    payload,
    content = '',
    original_query,
    clean_query,
  } = message || {};

  const getCardToDisplay = () => {
    if (!payload) {
      return null;
    }

    switch (message_type) {
      case MessageType.RESEARCH_TASK_CREATION_CARD:
        return (
          <ThreadResearchCard
            message={message}
            messageId={messageId}
            researchCard={(payload as ResearchTaskCreationCard).research_card}
            // TODO(olha): this is a workaround! needs to change condition and moves to child components to avoid chain of props!!!
            isStreaming={isStreaming}
            onSetActiveTab={setActiveTab}
            messageSkill={messageSkill}
            taskTitle={taskTitle}
            taskState={taskState}
          />
        );
      case MessageType.SCHEDULER_TASK_CREATION_CARD:
        return (
          <ThreadScheduleCard
            messageId={messageId}
            calendarCard={
              (payload as SchedulerCreationCard)?.calendar_card || undefined
            }
            details={(payload as SchedulerCreationCard).details || ''}
            //TODO(olha): add prop from BE
            summary=""
            message={message}
          />
        );
      case MessageType.ERROR_MESSAGE:
        return (
          <ThreadErrorMessageContent
            content={content}
            errorCode={(payload as ErrorPayload).error_code}
            unsupportedSkills={(payload as ErrorPayload).unsupported_skills}
          />
        );
      case MessageType.CHAT_CARD:
        return (
          <ThreadChitChatCard
            messageId={messageId}
            chitChatCard={payload as ChitChatCard}
            isStreaming={isStreaming}
            onSetActiveTab={setActiveTab}
            message={message}
            messageSkill={messageSkill}
            taskTitle={taskTitle}
            isLast={isLast}
            taskState={taskState}
          />
        );
      case MessageType.VIDEO_CARD:
        return (
          <ThreadVideoGenCard message={message} taskState={taskState} isStreaming={isStreaming} />
        );
      case MessageType.IMAGE_CARD:
        return (
          <ThreadImageGenerationCard
            message={message}
            messageId={messageId}
            imageCard={payload as ImageCard}
            messageOriginalQuery={original_query || ''}
            messageCleanQuery={clean_query || ''}
            taskState={taskState}
            isStreaming={isStreaming}
          />
        );
      default:
        return (
          <>
            <ThreadMessageContent
              content={content}
              isStreaming={isStreaming}
              messageSkill={messageSkill}
            />

            <RelatedQuestions message={message} isStreaming={isStreaming} />

            <FeedbackRating
              message={message}
              isStreaming={isStreaming}
              operationType="message-level"
              messageSkill={messageSkill}
            />
          </>
        );
    }
  };

  return (
    <DebugMessageWrapper message={message}>
      {getCardToDisplay()}
    </DebugMessageWrapper>
  );
};
